import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Draggable } from '@hello-pangea/dnd';
import { ImageField } from 'team-hero-ui';

import {
  AvatarBorderStyled,
  AvatarSignStyled,
  ImageDetailsContainerStyled,
} from './CustomImageField.styled';
import { ICustomImageFieldProps } from './CustomImageField.types';

const CustomImageField: FC<ICustomImageFieldProps> = ({
  index,
  item,
  isDraggingOver,
  disabled = false,
  onDeleteImgCallback,
  styleType = 'modal',
}) => {
  const { t } = useTranslation('general');
  const isAvatar = index === 0;

  if (item.iri) {
    return (
      <>
        <ImageDetailsContainerStyled>
          <Draggable
            draggableId={index.toString()}
            index={index}
            isDragDisabled={disabled}
          >
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <ImageField
                  key={item.url}
                  imgUrl={item.url}
                  onDelete={() => onDeleteImgCallback(index)}
                  disabled={disabled}
                />
              </div>
            )}
          </Draggable>
          <AvatarSignStyled
            $styleType={styleType}
            $displayText={isAvatar && !isDraggingOver}
          >
            {t('modal.labels.avatar')}
          </AvatarSignStyled>
        </ImageDetailsContainerStyled>
        {isAvatar && !isDraggingOver && <AvatarBorderStyled />}
      </>
    );
  }

  return (
    <>
      <ImageDetailsContainerStyled>
        <Draggable draggableId={index.toString()} index={index}>
          {(provided) => {
            return (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <ImageField
                  key={item.name}
                  imgUrl=''
                  file={item}
                  onDelete={() => onDeleteImgCallback(index)}
                />
              </div>
            );
          }}
        </Draggable>
        <AvatarSignStyled
          $styleType={styleType}
          $displayText={isAvatar && !isDraggingOver}
        >
          {t('modal.labels.avatar')}
        </AvatarSignStyled>
      </ImageDetailsContainerStyled>
      {isAvatar && !isDraggingOver && <AvatarBorderStyled />}
    </>
  );
};

export default CustomImageField;
